import {memo} from 'react'
/*
Author: Maxence Machu
Props:
• Current: Index actuel de SwippableView
• elKey: clé de l'élément actuel
 */
const OptimizedSlider = ({children, current, elKey, size}) => {
    // useState non utilisé car current et elKey sont des states de l'élément parent
    let shouldRender = false;

    // Multiple IF au lieu d'un switch pour améliorer la visibilité
    if( current + 1 === elKey || current - 1 === elKey){
        shouldRender = true;
    }
    if(current === elKey){
        shouldRender = true;
    }

    return (
        <>
            {shouldRender ? children : null}
        </>
    )
}

export default memo(OptimizedSlider);
